/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SelectApiSource {
  None = 'None',
  AnswerSet = 'AnswerSet',
  Activity = 'Activity',
  AmlRisk = 'AmlRisk',
  BankingProduct = 'BankingProduct',
  Benchmark = 'Benchmark',
  CaseType = 'CaseType',
  Channel = 'Channel',
  ClientType = 'ClientType',
  ClientSubType = 'ClientSubType',
  Country = 'Country',
  CountryReferral = 'CountryReferral',
  Currency = 'Currency',
  Dashboard = 'Dashboard',
  DocumentType = 'DocumentType',
  ClientProductDocumentTypes = 'ClientProductDocumentTypes',
  MailingInstructionDocumentTypes = 'MailingInstructionDocumentTypes',
  DocumentRequirementType = 'DocumentRequirementType',
  EconomicActivity = 'EconomicActivity',
  FamilyRelationshipType = 'FamilyRelationshipType',
  FeeStructure = 'FeeStructure',
  FinancialRecordSubType = 'FinancialRecordSubType',
  FormName = 'FormName',
  ListType = 'ListType',
  GoalType = 'GoalType',
  InsuranceProduct = 'InsuranceProduct',
  InvestmentProduct = 'InvestmentProduct',
  PensionProduct = 'PensionProduct',
  ProductLine = 'ProductLine',
  ProductCategory = 'ProductCategory',
  ProjectTemplate = 'ProjectTemplate',
  ProjectTemplateTask = 'ProjectTemplateTask',
  Language = 'Language',
  LendingProduct = 'LendingProduct',
  WealthManagementProduct = 'WealthManagementProduct',
  Mandate = 'Mandate',
  MandateGroup = 'MandateGroup',
  NationalIdentifierType = 'NationalIdentifierType',
  NudgeType = 'NudgeType',
  Objective = 'Objective',
  OrganisationClientType = 'OrganisationClientType',
  OrganisationRelationshipType = 'OrganisationRelationshipType',
  OrganisationToPersonRelationshipType = 'OrganisationToPersonRelationshipType',
  OrganisationToPersonEmploymentRoles = 'OrganisationToPersonEmploymentRoles',
  OrganisationType = 'OrganisationType',
  PersonType = 'PersonType',
  KanbanTypes = 'KanbanTypes',
  KanbanStages = 'KanbanStages',
  PortfolioProduct = 'PortfolioProduct',
  ParentProduct = 'ParentProduct',
  Product = 'Product',
  ProductFormName = 'ProductFormName',
  ProductType = 'ProductType',
  ProductFee = 'ProductFee',
  ProductCriteriaType = 'ProductCriteriaType',
  ProfessionalRelationshipType = 'ProfessionalRelationshipType',
  RelationshipType = 'RelationshipType',
  RelationshipToChild = 'RelationshipToChild',
  RelationshipToParent = 'RelationshipToParent',
  ExternalClientRelationships = 'ExternalClientRelationships',
  ClientRelationshipType = 'ClientRelationshipType',
  QiStatus = 'QiStatus',
  QueryRollupColumn = 'QueryRollupColumn',
  Region = 'Region',
  Report = 'Report',
  RiskLevel = 'RiskLevel',
  RiskProfileQuestion = 'RiskProfileQuestion',
  Role = 'Role',
  RoleSubType = 'RoleSubType',
  TeamType = 'TeamType',
  Salutation = 'Salutation',
  ServiceType = 'ServiceType',
  SystemEntity = 'SystemEntity',
  TagCategory = 'TagCategory',
  Tenant = 'Tenant',
  Title = 'Title',
  Unit = 'Unit',
  UnitGroup = 'UnitGroup',
  UserRole = 'UserRole',
  View = 'View',
  ViewForList = 'ViewForList',
  RoleContactPlays = 'RoleContactPlays',
  AssetTypes = 'AssetTypes',
  LiabilityTypes = 'LiabilityTypes',
  IncomeTypes = 'IncomeTypes',
  ExpenseTypes = 'ExpenseTypes',
  ProtectionTypes = 'ProtectionTypes',
  PersonalWealthSourceTypes = 'PersonalWealthSourceTypes',
  InstitutionalWealthSourceTypes = 'InstitutionalWealthSourceTypes',
  FundsOriginTypes = 'FundsOriginTypes',
  SourceSystems = 'SourceSystems',
  ProcessTypeCode = 'ProcessTypeCode',
  WorkItemTypeCode = 'WorkItemTypeCode',
  Privileges = 'Privileges'
}
